<template>
    <Wrapper>
        <h1 class="text-center mb-3">{{ $t('header', { name: userName }) }}</h1>
        <p class="text-center mb-4">{{ $t('description') }}</p>
        <h3 class="text-center mb-5">{{ $t('subheader') }}</h3>
        <FeatureColumns :columns="columns" />
    </Wrapper>
</template>



<script>
    import FeatureColumns from './parts/FeatureColumns.vue';
    import Wrapper from './parts/Wrapper.vue';

    export default {
        name: 'EntryPage',
        components: {
            Wrapper,
            FeatureColumns,
        },
        computed: {
            columns() {
                return Object.values(this.$t('columns')).map(column => ({ ...column, items: Object.values(column.items) }));
            },
            user() {
                return this.$store.getters['auth/getUser'];
            },
            userName() {
                return this.user?.firstName;
            },
            userRoleShort() {
                return this.$store.getters['auth/getRoleShortName'];
            },
            spaceCount() {
                return this.$store.getters['space/spaceCount'];
            },
        },
    };
</script>



<i18n lang="json" locale="pl" scope="local">
{
    "header": "Cześć, {name}!",
    "description": "Cieszymy się, że jesteś częścią naszej społeczności twórców, wydawców i właścicieli stron, którzy monetyzują swoją obecność w sieci na własnych zasadach. Na początek wybierz, która forma monetyzacji najlepiej pasuje do Ciebie — od tego zaczniemy.",
    "subheader": "Od czego chcesz zacząć swoją przygodę?",
    "columns": [
        {
            "title": "💸 Afiliacja",
            "description": "Polecaj sklepy oraz produkty i zarabiaj prowizje za każde zakupy z Twoich linków",
            "items": ["Idealne, jeśli prowadzisz bloga, stronę, kanał lub social media.", "Dostęp do tysięcy produktów i wygodne narzędzia afiliacyjne.", "Gotowe widżety, linki, strony produktowe — zero kodowania."],
            "button": {
                "label": "Zaczynamy",
                "to": { "name": "EntryPageBuyBox" }
            }
        },
        {
            "title": "☕ Napiwki (tip.BOX)",
            "description": "Pozwól swoim odbiorcom podziękować Ci za to, co robisz.",
            "items": ["Świetne rozwiązanie dla twórców, edukatorów i aktywistów.", "Prosty widżet na stronę lub link do profilu — zbieraj wsparcie jednym kliknięciem.", "Proste wdrożenie bez kodowania."],
            "button": {
                "label": "Zaczynamy",
                "to": { "name": "EntryPageTipBox" }
            }
        }
    ]
}
</i18n>

<i18n lang="json" locale="en" scope="local">
{
    "header": "Hi, {name}!",
    "description": "We are glad that you are part of our community of creators, publishers and website owners who monetize their presence on the web on their own terms. To start with, choose which form of monetization suits you best — we’ll begin there.",
    "subheader": "Where do you want to start your adventure?",
    "columns": [
        {
            "title": "💸 Affiliation",
            "description": "Recommend stores and products and earn commissions for every purchase made through your links",
            "items": ["Perfect if you run a blog, website, channel or social media.", "Access to thousands of products and handy affiliate tools.", "Ready-made widgets, links, product pages — zero coding."],
            "button": {
                "label": "Let’s get started",
                "to": { "name": "EntryPageBuyBox" }
            }
        },
        {
            "title": "☕ Tips (tip.BOX)",
            "description": "Let your audience thank you for what you do.",
            "items": ["A great solution for creators, educators and activists.", "A simple widget on your site or a profile link — collect support with one click.", "Easy setup with no coding."],
            "button": {
                "label": "Let’s get started",
                "to": { "name": "EntryPageTipBox" }
            }
        }
    ]
}
</i18n>
